// Global class names.
export const HIDE: string = 'hide'

// Body classes.
export const BODY_SCROLL_HIDE: string = 'scroll-hidden'

// Main menu classes.
export const MM_BACKDROP_CLASS: string = 'backdrop'
export const MM_ACTIVE_BACKDROP_CLASS: string = 'mm-backdrop-active'

// Button classes.
export const INLINE_BUTTON_CLASS: string = 'cInputBtnInline'
export const COOKIE_CONSENT_BUTTON_CLASS: string = 'ccb-button'
